export function formatItemDisplayName(productLike, itemNameFormat = 'name_sku') {
  const name = productLike?.name || 'Item';
  const sku = productLike?.sku;
  const brand = productLike?.brand;

  switch (itemNameFormat) {
    case 'name':
      return name;
    case 'name_sku':
      return sku ? `${name} (${sku})` : name;
    case 'name_brand':
      return brand ? `${name} - ${brand}` : name;
    case 'name_brand_sku':
      if (brand && sku) return `${name} - ${brand} (${sku})`;
      if (brand) return `${name} - ${brand}`;
      if (sku) return `${name} (${sku})`;
      return name;
    case 'brand_name':
      return brand ? `${brand} - ${name}` : name;
    case 'brand_name_sku':
      if (brand && sku) return `${brand} - ${name} (${sku})`;
      if (brand) return `${brand} - ${name}`;
      if (sku) return `${name} (${sku})`;
      return name;
    default:
      return sku ? `${name} (${sku})` : name;
  }
}

